import React from "react";
import { Button, DateRangePicker, Input, SelectPicker } from "rsuite";
import config from "../../../globals";
import axios from "../../../utilities/axios";
import { notify } from "../../../utilities/notify";
import { AxiosSelectPicker } from "../../formfields/AxiosSelectPicker";

export class ProjectReport extends React.Component<any, {}> {
    public state: any = {
        filter: {
            codigo_projeto: null,
            data_vencimento: [],
            integration_id: null,
            cnpj_cpf: "",
            company_name: ""
        },
        loadedData: {
            companies: [],
        },
        isLoading: false
    }

    componentDidMount(): void {
        this.loadCompanies();
    }

    onSubmitButton = () => {
        const { integration_id } = this.state.filter;
        if (integration_id == null) {
            notify("É obrigatório preencher a empresa.", "warning");
            return;
        }
        this.setState({ isLoading: true });
        axios.post("/api/v1/reports/projects", {
            params: {
                filter: this.state.filter
            }
        }).then((res) => {
            if (res?.status === 200) {
                if (config.url.includes("localhost")) {
                    config.url = config.url.split('25565').join('25567');
                }
                if (res.data.output) {
                    window.open(config.url + res.data.output, "_blank");
                } else {
                    notify("Nenhum registro encontrado.", "error");
                }
            }
        }).finally(() => {
            this.setState({ isLoading: false });
        });
    }

    loadCompanies = async () => {
        try {
            const { data } = await axios.get("/api/v1/integration/getAllActives")

            if (data?.data?.length === 0) return

            const formattedData = data?.data.map((company: any) => {
                return {
                    value: company.integration_id,
                    label: `${company.integration_company_cnpj} - ${company.integration_name}`
                }
            })

            this.setState({ ...this.state, loadedData: { companies: formattedData } });
        } catch (error) {
            console.log("Erro ao carregar empresas", error)
            notify("Não foi possível carregar empresas", "warning");
        }
    }

    render() {
        const { codigo_projeto, cnpj_cpf, integration_id, company_name, data_vencimento } = this.state.filter;
        const { companies } = this.state.loadedData;

        return (
            <div style={{ width: "100%" }}>
                <div style={{ width: "100%", display: "flex", margin: "auto", gap: 3, marginBottom: 16 }}>
                    <div style={{ display: "flex", flexDirection: "column", width: "30%" }}>
                        <label>Empresa</label>
                        <SelectPicker
                            data={companies}
                            value={this.state.filter.integration_id}
                            onChange={(value) => {
                                this.setState({
                                    ...this.state.filter, filter: {
                                        ...this.state.filter,
                                        integration_id: value
                                    }
                                })
                            }}
                            placeholder="Selecione uma Empresa"
                        />
                    </div>

                    {/* <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                        <label>CNPJ/CPF (do cliente)</label>
                        <Input
                            value={cnpj_cpf}
                            placeholder={"Digite o CNPJ/CPF"}
                            disabled={this.state.isLoading}
                            onChange={(value) => {
                                this.setState({
                                    ...this.state.filter, filter: {
                                        ...this.state.filter,
                                        cnpj_cpf: value
                                    }
                                })
                            }}
                            // onBlur={() => {
                            //     const digits = (cnpj_cpf || '').toString().replace(/\D/g, '');
                            //     if (digits && digits.length === 14) {
                            //         this.setState({ isLoading: true });
                            //         axios.get(`/api/v1/consulta-cnpj/${digits}`)
                            //             .then((res) => {
                            //                 const data = res?.data?.data;
                            //                 if (data && data.nome) {
                            //                     this.setState({
                            //                         ...this.state.filter, filter: {
                            //                             ...this.state.filter,
                            //                             company_name: data.nome
                            //                         }
                            //                     })
                            //                 }
                            //             })
                            //             .finally(() => {
                            //                 this.setState({ isLoading: false });
                            //             });
                            //     }
                            // }}
                        />
                    </div> */}

                    {/* <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                        <label>RAZÃO SOCIAL (do cliente)</label>
                        <Input
                            value={company_name}
                            placeholder={"Digite a razão social"}
                            disabled={this.state.isLoading}
                            onChange={(value) => {
                                this.setState({
                                    ...this.state.filter, filter: {
                                        ...this.state.filter,
                                        company_name: value
                                    }
                                })
                            }}
                        />
                    </div> */}

                    {this.state.filter.integration_id != null && (
                        <div style={{ width: "50%", display: "flex", margin: "auto", gap: 3, marginBottom: 16 }}>
                            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                <label>Cliente</label>
                                <AxiosSelectPicker
                                    name="project"
                                    api={{
                                        method: "GET",
                                        url: `/api/v1/omie/list/clients?id=${integration_id}`
                                    }}
                                    disabled={this.state.isLoading}
                                    value={cnpj_cpf}
                                    onChange={(value: any) => {
                                        this.setState({
                                            ...this.state.filter, filter: {
                                                ...this.state.filter,
                                                cnpj_cpf: value
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    <div style={{ display: "flex", flexDirection: "column", width: "30%" }}>
                        <label>DATA (do vencimento do título) (De/Até)</label>
                        <DateRangePicker
                            format="dd/MM/yyyy"
                            preventOverflow
                            // locale={locale}
                            defaultValue={data_vencimento}
                            disabled={this.state.isLoading}
                            onChange={(value) => {
                                this.setState({
                                    ...this.state.filter, filter: {
                                        ...this.state.filter,
                                        data_vencimento: value
                                    }
                                })
                            }}
                        />
                    </div>
                </div>

                {this.state.filter.integration_id != null && (
                    <div style={{ width: "100%", display: "flex", margin: "auto", gap: 3, marginBottom: 16 }}>
                        <div style={{ display: "flex", flexDirection: "column", width: "27.3%" }}>
                            <label>Projeto</label>
                            <AxiosSelectPicker
                                name="project"
                                api={{
                                    method: "GET",
                                    url: `/api/v1/omie/list/projects?id=${integration_id}`
                                }}
                                disabled={this.state.isLoading}
                                value={codigo_projeto}
                                onChange={(value: any) => {
                                    this.setState({
                                        ...this.state.filter, filter: {
                                            ...this.state.filter,
                                            codigo_projeto: value
                                        }
                                    })
                                }}
                            />
                        </div>
                    </div>
                )}

                <div style={{ width: "100%", display: "flex", margin: "auto", gap: 5, marginBottom: 8 }}>
                    <div style={{ display: "flex", flexDirection: "column", width: "20%", marginTop: 20 }}>
                        <Button loading={this.state.isLoading} onClick={() => this.onSubmitButton()} appearance="primary" color="green"><i className="fas fa-fw fa-file-excel"></i> Gerar Excel</Button>
                    </div>
                </div>
                {/* {JSON.stringify(this.state.filter)} */}
            </div>
        )
    }
}
